var React = require('react');
var selectableData = require('./selectableData.jsx');
var apiDataRepository = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/selectableApiData.jsx');

var selectableDataFunctions = {
    getStateSelectableOptions: function (props) {
        if (selectableData['states'][props.country]) {
            return selectableData['states'][props.country].map(function (state, index) {
                return <option value={state} key={state + index}>{state}</option>;
            });
        }
    },
    getBillingAddressTypeOptions: function(props) {
        return selectableData[props.name].filter((addressType) => {
            return addressType !== props.step3addresstype;
        }).map(function (item, index) {
            return <option value={item} key={item + index}>{item}</option>;
        });
    },
    getApiSelectableOptions: function (props) {
        var selectable = props.selectoptions ? props.selectoptions : props.name;
        if (selectableData[selectable] && selectableData[selectable].length) {
            return selectableData[selectable].filter(function(item) {
                return item.ActiveFlag;
            }.bind(this)).map(function (item, index) {
                return <option value={item[props.valueprop]} key={item[props.valueprop]}>{item[props.labelprop]}</option>;
            }.bind(this));
        }
    },
    getMedicalLicenseStates: function (props) {
        if (selectableData["countriesAndStates"] && selectableData["countriesAndStates"].length) {
            var countryData = selectableData["countriesAndStates"].filter(function (item) {
                return item.Country.CountryCode === 'USA';
            }.bind(this));

            if (countryData && countryData.length) {
                return countryData[0].States.filter(function (state) {
                    var militaryFilter = props.military === "false" ? state.StateCode !== 'USSA' : true;
                    return militaryFilter && state.StateCode !== 'OTHER';
                }).map(function (item, index) {
                    return <option value={item["StateCode"]} key={item["StateCode"]}>{item["StateDescription"]}</option>;
                }.bind(this));
            }
        }
    },
    getApiDistricts: function (props) {
        var chosenPrimaryPracticeLocation = this.ppl;

        if (selectableData["districts"] && selectableData["districts"].length && chosenPrimaryPracticeLocation) {
            var districtCodes = selectableData["districts"].map(x => ({
                distictCode: x.Code,
                districtDesc: x.Description,
                districtStatecode: x.StateCode.toUpperCase()
            }));

            let uniqueDistictCodes = [];
            districtCodes.map(x => uniqueDistictCodes.filter(a => a.distictCode == x.distictCode && a.districtDesc == x.districtDesc && a.districtStatecode == x.districtStatecode).length > 0 ? null : uniqueDistictCodes.push(x));

            let districtlistfilterbyPPL = uniqueDistictCodes.filter(function (districtlist) {
                return districtlist.districtStatecode == chosenPrimaryPracticeLocation
            });

            return districtlistfilterbyPPL.map(function (option, index) {
                return <option value={option.distictCode} key={option.distictCode}>{option.districtDesc}</option>;
            });
        }
    },
    getApiPrimaryPracticeOptions: function (props) {
    
        if (selectableData["primaryPracticeLocations"] && selectableData["primaryPracticeLocations"].length) {
            var options = selectableData["primaryPracticeLocations"];


            return options
                .sort((a, b) => a.Name.localeCompare(b.Name))
                .map((option, index) => (
                    <option value={option.Name} key={option.Name}>
                        {option.Description}
                    </option>
                ));

          
        }
    },
    getApiStatesFromAllCountries: function (props) {
        if (selectableData["countriesAndStates"] && selectableData["countriesAndStates"].length) {
            var countryData = selectableData["countriesAndStates"].filter(function(item) {
                return item.Country.CountryCode === props.country;
            }.bind(this));
            
            if (countryData && countryData.length) {
                return countryData[0].States.map(function (item, index) {
                    return <option value={item["StateCode"]} key={item["StateCode"]}>{item["StateDescription"]}</option>;
                }.bind(this));
            }
        }
    },
    getApiCountriesFromAllCountries: function (props) {
        if (selectableData["countriesAndStates"] && selectableData["countriesAndStates"].length) {
            return selectableData["countriesAndStates"].filter(function(item) {
                return item.Country.ActiveFlag;
            }).map(function(item) {
                return <option value={item.Country.CountryCode} key={item.Country.CountryCode}>{item.Country.CountryDescription}</option>;
            });
        }
    },    
    getEthnicityDropdownOptions: function (props) {
        if (selectableData["ethnicity"] && selectableData["ethnicity"].length) {
            var options = selectableData["ethnicity"];

            return options.map(function (option, index) {
                return <option value={option.Name} key={option.Name}>{option.Description}</option>;
            });
        }
    },
    getRaceDropdownOptions: function (props) {
        if (selectableData["race"] && selectableData["race"].length) {
            var options = selectableData["race"];

            return options.map(function (option, index) {
                return <option value={option.Name} key={option.Name}>{option.Description}</option>;
            });
        }
    },
    getGenderDropdownOptions: function (props) {
        if (selectableData["gender"] && selectableData["gender"].length) {
            var options = selectableData["gender"];

            return options.map(function (option, index) {
                return <option value={option.Name} key={option.Name}>{option.Description}</option>;
            });
        }
    },
    getPrefixDropdownOptions: function (props) {
        if (selectableData["prefix"] && selectableData["prefix"].length) {
            var options = selectableData["prefix"];

            if (props.removemilitary) {
                options = options.filter(function(option) {
                    return !option.IsMilitary;
                });
            }

            return options.map(function(option, index) {
                return <option value={option.Code} key={option.Code}>{option.Description}</option>;
            });
        }
    },
    getSuffixDropdownOptions: function (props) {
        if (selectableData["suffix"] && selectableData["suffix"].length) {
            var options = selectableData["suffix"];            
            return options.map(function (option, index) {
                return <option value={option.Code} key={option.Code}>{option.Description}</option>;
            });
        }
    },
    getInstitutionSelectableOptions: function (props) {
        var institutionState = props.userdefinedstate ? props.userdefinedstate : props.UserDefinedState;
        var institutionCountry = props.userdefinedcountry ? props.userdefinedcountry : '';

       /* var programTypeCode = props.programtypecode;*/
        return selectableData['institutions'] ? selectableData['institutions'].filter(function (institution, index) {
            // if we set a country on the dropdown props, short circuit
            if (institutionState) {
                return (institutionState === institution.State && institution.State !== '');
            }

            return institutionCountry === institution.CountryCode && institution.CountryCode !== '';
        }).map(function(institution, index) {
            return <option value={institution.InstitutionName} key={index}>{institution.InstitutionName}</option>;
        }) : [];
    },
    getFellowshipSubTypeSelectableOptions: function (props) {
        var selectedFellowship = props.fellowshipcode ? props.fellowshipcode : '';
        return selectableData['fellowshipSubType'] ? selectableData['fellowshipSubType'].map(function (subType, index) {
            if ((selectedFellowship === subType.Code && subType.Code !== '') || !selectedFellowship)
                return <option value={subType.Subcode} key={index}>{subType.Description}</option>;
        }) : [];
    },
    //getProgDegreeSelectableOptions: function (props) {
    //    return selectableData['activeProgramDegrees'] && selectableData['activeProgramDegrees'].length ? selectableData['activeProgramDegrees'].map(function (degree, index) {
    //        return <option value={degree.Code} key={index}>{degree.Description}</option>;
    //    }) : [];
    //},
    getBoardCertificationOptions: function(props) {
        return selectableData.boardTitle.map(function(board, index) {
            return <option value={board} key={index}>{board.replace('_ID', '')}</option>;
        });
    },
    getMilitaryBranchSelectableOptions: function(props) {
        return selectableData['militaryBranch'].map(function(branch, index) {
            return <option value={branch.Subcode} key={branch.Subcode}>{branch.Description}</option>;
        });
    },
    getDescriptionSelectableOptions: function (props) {
        var selectable = props.selectoptions ? props.selectoptions : props.name;
        var code = props.code ? props.code : 'Code';

        if (props.distinctoptions) {
            return selectableData[selectable].filter((item) => {
                return item.Subcode.includes(props.distinctoptions) && !item.Subcode.includes('_ID');
            }).map((returnItem, key) => {
                return <option value={returnItem[code]} key={key}>{returnItem.Description}</option>;
            });
        }

        return selectableData[selectable] ? selectableData[selectable].map(function (item, index) {
            return <option value={item[code]} key={item.Description + index}>{item.Description}</option>;
        }) : [];
    },
    getSelectableOption: function (props) {
        var selectable = props.selectoptions ? props.selectoptions : props.name;
        return selectableData[selectable].map(function (item, index) {
            return <option value={item} key={item + index}>{item}</option>;
        });
    },
    
    getCheckboxMultiSelectOptions: function (props) {
        var selectable = props.selectoptions ? props.selectoptions : props.name;
        return selectableData[selectable].map(function (item, index) {
            return <div key={item.Description + index}>
                <input type="checkbox"
                    name={props.name}
                    checked={props.value.includes(item.Code)}
                    onChange={props.onChange}
                    value={item.Code} />
                <span>{item.Description}</span>
            </div>;
        });
    },
    getRadioButtonOptions: function(props) {
        var selectable = props.selectoptions ? props.selectoptions : props.name;
        return selectableData[selectable].map(function (item, index) {

            const value = item.Name ? item.Name : item;
            const description = item.Description ? item.Description : item;

            return <div key={description + index}>
                <input
                    type="radio"
                    name={props.name}
                    value={value}
                    onChange={props.onChange}
                    checked={props.value === value} /> {description}
            </div>;
        });
    },
    getRadioButtonOptionsWithLabels: function (props) {
        var selectable = props.selectoptions ? props.selectoptions : props.name;
        return selectableData[selectable].map(function (item, index) {
            return <div key={item.value + index}>
                <input
                    type="radio"
                    name={props.name}
                    value={item.value}
                    onChange={props.onChange}
                    checked={props.compareValue === item.value || props.compareValue === item.value.toString()} /> {item.label}
            </div>;
        });
    },
    governmentSectorRadioButtons: function (props) {
        var selectable = props.selectoptions ? props.selectoptions : props.name;
        return selectableData[selectable].map(function(item, index) {
            return <div key={item.Subcode}>
                <input type="radio"
                    name={props.name}
                    value={item.Subcode}
                    onChange={props.onChange}
                    checked={props.value === item.Subcode}/> {item.Description}
                   </div>;
        });
    }
};

module.exports = selectableDataFunctions;